/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ProjectCentre } from './ProjectCentre';
import {
    instanceOfProjectCentre,
    ProjectCentreFromJSON,
    ProjectCentreFromJSONTyped,
    ProjectCentreToJSON,
} from './ProjectCentre';

/**
 * @type OtherSystemSourceWithCentreAndDomainProjectCentre
 * 
 * @export
 */
export type OtherSystemSourceWithCentreAndDomainProjectCentre = ProjectCentre;

export function OtherSystemSourceWithCentreAndDomainProjectCentreFromJSON(json: any): OtherSystemSourceWithCentreAndDomainProjectCentre {
    return OtherSystemSourceWithCentreAndDomainProjectCentreFromJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainProjectCentreFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherSystemSourceWithCentreAndDomainProjectCentre {
    if (json == null) {
        return json;
    }
    if (instanceOfProjectCentre(json)) {
        return ProjectCentreFromJSONTyped(json, true);
    }

    return {} as any;
}

export function OtherSystemSourceWithCentreAndDomainProjectCentreToJSON(json: any): any {
    return OtherSystemSourceWithCentreAndDomainProjectCentreToJSONTyped(json, false);
}

export function OtherSystemSourceWithCentreAndDomainProjectCentreToJSONTyped(value?: OtherSystemSourceWithCentreAndDomainProjectCentre | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfProjectCentre(value)) {
        return ProjectCentreToJSON(value as ProjectCentre);
    }

    return {};
}

